module.exports = __webpack_public_path__ + "img/icon_5_24.3306eda0.png";